export const storageKeyToken = 'ej_token';
export const storageKeyUser = 'ej_currentUser';